// AI Enhance — uses the buyer's Groq API key (from Settings) to enhance the proposal.
// The PWA works fully without this; the key is optional.

import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiEnhanceProposal(
  markdown: string,
  onStream: (chunk: string) => void
): Promise<void> {
  const system = `You are a freelance business attorney and proposal writer. Strengthen this SOW with: 1) Clearer acceptance criteria per deliverable, 2) Stronger payment protections, 3) Persuasive value propositions in the executive summary, 4) Fair but protective terms. Maintain professional tone. Output the full enhanced proposal in Markdown.`;
  try {
    await streamGroq({
      messages: [
        { role: 'system', content: system },
        { role: 'user', content: markdown },
      ],
      temperature: 0.3,
      onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) {
      onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ in the header to paste your free key from console.groq.com/keys. The core logic above works fully without it.');
      return;
    }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
